// extracted by mini-css-extract-plugin
export var colorSquare = "_u5-0";
export var danger = "_u5-5";
export var lightPink = "_u5-8";
export var neutralBlue = "_u5-7";
export var neutralYellow = "_u5-6";
export var normal = "_u5-1";
export var primary = "_u5-2";
export var primaryLight = "_u5-3";
export var solidBlack = "_u5-g";
export var solidGreen = "_u5-b";
export var solidLightBlue = "_u5-d";
export var solidNavy = "_u5-c";
export var solidOrange = "_u5-f";
export var solidPink = "_u5-e";
export var solidRed = "_u5-9";
export var solidYellow = "_u5-a";
export var success = "_u5-4";